import { ConfigColumnDefs, ConfigColumns } from "datatables.net";

export const listActionsColumns: ConfigColumns[] = [
    { title: "Azioni", data: "id" },
    { title: "Codice", data: "code" },
    { title: "Nome", data: "name" },
];

export default function getListActionsColumnDefs(): ConfigColumnDefs[] {
    return [
        {
            target: 0,
            width: "10%",
            render: (id: number, type: string, row: any) => {
                const edit = `<a class="edit_btn custom-icon btn topic-empty-btn-color rounded-circle me-1" data-id="${id}" title="Modifica azione">
                                <i style="font-size: 18px" class="fa fa-pencil" aria-hidden="true"></i>
                            </a>`;
                const trash = `<a class="delete_btn custom-icon btn btn-outline-danger rounded-circle me-1" data-id="${id}" title="Elimina azione">
                                <i style="font-size: 18px" class="fa fa-trash" aria-hidden="true"></i>
                            </a>`;
                return '<div class="d-flex">' + edit + trash + '</div>';
            },
        }
    ];
}
